import { Alert, Box, useTokens } from '@barracuda-internal/bds-core-v2'
import React, { useMemo, useState } from 'react'
import { useAppSelector } from 'redux/toolkit/hooks'
import { useErrorParam } from '../../login/useErrorParam'

const ErrorComponent: React.FC = () => {
  const tokens = useTokens()

  const [error, setError] = useState('')
  const [errorDescription, setErrorDescription] = useState('')

  // BNESS-32535: only a failed domain commit at consent time (WizardServiceFailed) carries a backend reason worth
  // showing. Other OAuth errors keep the mapped title alone, e.g. AADSTS65004 maps to "User declined to consent".
  useErrorParam({
    stayOnRoute: true,
    showDescriptionFor: ['WizardServiceFailed'],
    setTopErrorMessage: setError,
    setTopErrorDescription: setErrorDescription
  })

  const { setupFlowError, newMxRecordsError, oldMxRecordsError } = useAppSelector(_store => ({
    setupFlowError: _store.emailServer.setupFlowError,
    newMxRecordsError: _store.emailServer.emailFlowState.newRecordsError,
    oldMxRecordsError: _store.emailServer.emailFlowState.oldRecordsError
  }))

  const errors = useMemo(() => {
    // BNESS-32535: the title and, when forwarded, the backend reason are separate alerts, so a failed domain
    // commit at consent time tells the user which domain failed and why
    const possibleErrors = [error, errorDescription, setupFlowError, newMxRecordsError, oldMxRecordsError]
    return possibleErrors.filter((possibleError): possibleError is string => !!possibleError)
  }, [error, errorDescription, setupFlowError, newMxRecordsError, oldMxRecordsError])

  return useMemo(
    () =>
      errors.length > 0 ? (
        <Box
          sx={{ paddingRight: tokens.aliasesSpaceContainerDefault, paddingLeft: tokens.aliasesSpaceContainerDefault }}
        >
          {errors.map((e, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Alert key={index} bdsBoxShadowType="inline" bdsType="neutralError">
              {e}
            </Alert>
          ))}
        </Box>
      ) : null,
    [tokens, errors]
  )
}

export default ErrorComponent
